import React from "react";

import { Row, useFieldValue } from "2g-form";

import {
  ACZakaznici,
  ACZakaznikUzivatele,
  ACZakaznikProjekty
} from "b2b/components/autocompletes";

export function RezervaceVytvoreniProjekt() {
  const zakaznik = useFieldValue("zakaznik");

  return (
    <Row styled>
      <ACZakaznici path="zakaznik" />
      <ACZakaznikUzivatele
        path="uzivatel"
        zakaznikICO={zakaznik?.ico}
        disabled={!zakaznik}
      />
      <ACZakaznikProjekty
        path="projekt"
        zakaznikICO={zakaznik?.ico}
        disabled={!zakaznik}
      />
    </Row>
  );
}

RezervaceVytvoreniProjekt.propTypes = {};

export default React.memo(RezervaceVytvoreniProjekt);
